import { Prettify } from '@givebacks/utils/types';
import { Button, Card, Group, Stack, Text, ThemeIcon } from 'ui';
import { useMatches } from 'ui/Hooks';
import { IconLoadingError } from 'ui/Icons';

import { ErrorBoundaryCardProps, FallBackComponentProps } from './types';

type ErrorCardProps = Prettify<FallBackComponentProps> & ErrorBoundaryCardProps;

const ErrorCard = ({
  title = 'Unable to load section',
  description,
  icon = true,
  withRetry = true,
  resetError,
}: ErrorCardProps) => {
  const buttonFullWidth = useMatches({
    base: true,
    sm: false,
  });
  return (
    <Card withBorder>
      <Group wrap="wrap" gap={16}>
        <Group wrap="nowrap">
          {icon && (
            <ThemeIcon variant="transparent" size={48}>
              <IconLoadingError size={48} />
            </ThemeIcon>
          )}
          <Stack gap={4}>
            <Text size="12px" fw="600" c="gray.6">
              {title}
            </Text>
            {description && (
              <Text size="10px" c="gray.6">
                {description}
              </Text>
            )}
          </Stack>
        </Group>

        {withRetry && (
          <Button fullWidth={buttonFullWidth} onClick={resetError} size="sm">
            Reload
          </Button>
        )}
      </Group>
    </Card>
  );
};

export { ErrorCard };
